(() => {
  // app/scripts/custom-lazyload.js
  var CustomLazyload = class extends HTMLElement {
    constructor() {
      super();
      this.lazyAssets = this.dataset.assets?.replace(/\r?\n|\r/g, "").split(",").map((asset) => asset.trim());
      this.isMobileDevice = window.matchMedia("(max-width: 767px)").matches;
      this.options = {
        rootMargin: this.isMobileDevice ? "-200px 0px -200px 0px" : "400px 0px 400px 0px"
      };
    }
    connectedCallback() {
      this.observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting)
          return;
        observer.unobserve(this);
        this.isIntersecting = true;
        this.loadAssets();
      }, this.options);
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (!this.isIntersecting)
        this.observer?.unobserve(this);
    }
    loadAssets() {
      if (!this.lazyAssets)
        return;
      const newAssets = this.lazyAssets.filter((asset) => !CustomLazyload.lazyloadedAssets.includes(asset));
      const promises = newAssets.map((asset) => {
        return new Promise((resolve, reject) => {
          CustomLazyload.lazyloadedAssets.push(asset);
          AT.loadScript(asset, function() {
            console.log("script::loaded::", asset);
            resolve(1);
          });
        });
      });
      Promise.all(promises).then(() => {
        this.setAttribute("loaded", "true");
      });
    }
  };
  CustomLazyload.lazyloadedAssets = [];
  customElements.define("c-lazyload", CustomLazyload);
})();
